import React from 'react';
import {IconProps} from './IconProps';
import LEGACY_COLORS from '@/styles/legacyColors';

export default function RecruitedIcon(props: IconProps) {
  const {width = 22, height = 22, color = LEGACY_COLORS.BLUE} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        id="Fill-3267"
        d="M7.33333333,9.16666667 C6.32225,9.16666667 5.5,9.988 5.5,11 C5.5,12.0110833 6.32225,12.8333333 7.33333333,12.8333333 C8.34441667,12.8333333 9.16666667,12.0110833 9.16666667,11 C9.16666667,9.988 8.34441667,9.16666667 7.33333333,9.16666667 M7.33333333,14.6666667 C5.31116667,14.6666667 3.66666667,13.0221667 3.66666667,11 C3.66666667,8.97783333 5.31116667,7.33333333 7.33333333,7.33333333 C9.3555,7.33333333 11,8.97783333 11,11 C11,13.0221667 9.3555,14.6666667 7.33333333,14.6666667"
        fill={color}
      />
      <path
        id="Fill-3268"
        d="M1.97880833,20.1666667 L12.688225,20.1666667 C12.1400583,18.5093333 10.0903917,17.4166667 7.33305833,17.4166667 C4.575725,17.4166667 2.526975,18.5093333 1.97880833,20.1666667 L1.97880833,20.1666667 Z M14.6663917,22 L-0.000275,22 L-0.000275,21.0833333 C-0.000275,17.84475 3.01555833,15.5833333 7.33305833,15.5833333 C11.651475,15.5833333 14.6663917,17.84475 14.6663917,21.0833333 L14.6663917,22 Z"
        fill={color}
      />
      <polygon
        id="Fill-3269"
        points="16.5 0 18.0711667 3.92883333 22 3.92883333 18.601 6.798 20.4279167 11 16.5 8.40216667 12.5711667 11 14.399 6.798 11 3.92883333 14.9279167 3.92883333"
        fill={color}
      />
    </svg>
  );
}
